import PropTypes from 'prop-types';

import getIcon from 'services/getIcon';

import './Title.scss';

const Title = ({ title = "Title", icon = "" }) => (
  <div className="navigation-mobile__navbar__title">
    <div className="navigation-mobile__navbar__title__icon">
      {getIcon({ color: "white-base", icon, size: 20 })}
    </div>
    <div className="navigation-mobile__navbar__title__text">
      {title}
    </div>
  </div>
)

Title.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string
}

export default Title;